import { GET_NOTIFIED_GAUGES, GaugesActions } from './types';
import { MapGaugesNotifications } from '../../../services/GaugesNotificationService';
export interface IGaugesState {
    gaugesNotifications: MapGaugesNotifications;
}
export const INITIAL_STATE: IGaugesState = { gaugesNotifications: new Map() };

export default function(state = INITIAL_STATE, action: GaugesActions) {
    switch (action.type) {
        case GET_NOTIFIED_GAUGES:
            const gaugesNotifications = action.payload;

            return {
                ...state,
                gaugesNotifications,
            };

        default:
            return state;
    }
}
